import * as types from "./employee.actionTypes";
import { createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { EmployeeListResponse } from "./types";

export const getEmployeeAsync = createAsyncAction(
  types.GET_EMPLOYEE_REQUEST,
  types.GET_EMPLOYEE_SUCCESS,
  types.GET_EMPLOYEE_FAILURE
)<undefined, EmployeeListResponse, ErrorResponse>();